import React from 'react';
import './Scoreboard.css';

// Grey retro status bar mirroring the Bit Tanks scoreboard (#statusIndicator).
// Compact, current-game-only contents (games balance and lifetime high score
// live in the Account Dash instead):
//   Row 1: player (P1) + live SCORE
//   Row 2 (during a game): spin-point LEDs — they count the spins down
//   Row 3: live message — SPIN TO WIN!, then LAST #n; when the running score
//          beats the stored high score the tail becomes a pulsing NEW HI!
const Scoreboard = ({ playerName, game, lastNumber, lastColor }) => {
  const isNewHi =
    !!game && (game.score ?? 0) > 0 && (game.score ?? 0) > (game.highScore ?? 0);

  return (
    <div className="wheel-scoreboard">
      <div className="wheel-scoreboard__player" title={playerName}>{playerName}</div>
      {game && (
        <div className="wheel-scoreboard__score">
          SCORE <b>{(game.score ?? 0).toLocaleString()}</b>
        </div>
      )}

      {game && (
        <div className="wheel-scoreboard__hud">
          <span className="wheel-scoreboard__markers" title={`Spins left: ${game.spinPoints}/${game.spinPointsTotal}`}>
            {Array.from({ length: game.spinPointsTotal }, (_, i) => (
              <i
                key={i}
                className={
                  i < game.spinPoints
                    ? 'wheel-scoreboard__marker'
                    : 'wheel-scoreboard__marker wheel-scoreboard__marker--spent'
                }
              />
            ))}
          </span>
        </div>
      )}

      <div className="wheel-scoreboard__message">
        {lastNumber != null ? (
          <>
            LAST:{' '}
            <span className="wheel-scoreboard__num" style={{ color: lastColor }}>
              #{lastNumber}
            </span>{' '}
            —{' '}
            {isNewHi ? (
              <span className="wheel-scoreboard__newhi">NEW HI!</span>
            ) : (
              'SPIN AGAIN!'
            )}
          </>
        ) : isNewHi ? (
          <span className="wheel-scoreboard__newhi">NEW HI!</span>
        ) : (
          'SPIN TO WIN!'
        )}
      </div>
    </div>
  );
};

export default Scoreboard;
